import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FuseNavigationItem } from '@fuse/types';
import { AuthenticationService } from 'app/modules-services/auth-services/authentication.service';
import { BehaviorSubject } from 'rxjs';
import { navigation } from './navigation';


@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    private lastRequestUrl = '/';

    private _navigation: BehaviorSubject<FuseNavigationItem[]> = new BehaviorSubject<FuseNavigationItem[]>([]);

    constructor(private _router: Router, private authenticationService: AuthenticationService, private location: Location) {}

    get navigation$() {
        return this._navigation.asObservable();
    }

    get navigation() {
        return this._navigation.value;
    }

    set navigation(value: FuseNavigationItem[]) {
        this._navigation.next(value);
    }

    get() {
        this.navigation = [...navigation];
        const roles = this.authenticationService.decodedToken?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
        this.navigation = this.filterNavigation(this.navigation, Array.isArray(roles) ? roles : [roles]);
        return this.navigation || [];
    }


    isAccessAllowed(url: string): boolean {
        // Gestione rotte figlie dinamiche che non sono presenti nel menu
        if (url.includes('/dettaglio-dichiarazione/')) {
            const parentUrl = url.split('/dettaglio-dichiarazione/')[0];
            return this.findItemByUrl(this.navigation, parentUrl) != null;
        }

        if (url.includes('/registrazioni/in-corso/')) {
            return this.findItemByUrl(this.navigation, '/registrazioni/spid') != null || 
                   this.findItemByUrl(this.navigation, '/registrazioni/completate') != null || 
                   this.findItemByUrl(this.navigation, '/registrazioni/apertura-partita-iva') != null;
        }

        return this.findItemByUrl(this.navigation, url) != null;
    }

    setRequestUrl(url: string) {
        this.lastRequestUrl = url !== '/auth/login' ? url : '/';
    }

    navigateToDashboard() {
        return this._router.navigate(['/']);
    }

    navigateToLastRequest() {
        return this._router.navigate([this.lastRequestUrl]);
    }

    navigatoToLogin() {
        return this._router.navigate(['/auth/login']);
    }

    navigaBack() {
        return this.location.back();
    }

    private findItemByUrl(navigation: FuseNavigationItem[], url: string): FuseNavigationItem {
        for (const item of navigation) {
            if (item.url === url && item.hidden === false) {
                return item;
            }

            if (item.children) {
                const found = this.findItemByUrl(item.children, url);
                if (found) {
                    return found;
                }
            }
        }

        return null;
    }

    private filterNavigation(navigation: FuseNavigationItem[], roles: string[]): FuseNavigationItem[] {
        return navigation.map(item => {
            const isVisible = item.roles ? item.roles.some(role => roles.includes(role)) : true;
            return {
                ...item,
                hidden: !isVisible,
                children: item.children ? this.filterNavigation(item.children, roles) : undefined,
            };
        });
    }
}
